import createMessage from '@/services/app/createMessage'
import { keys } from '@/util/helpers'
import { IdValueObject } from '@/interfaces/app/ValueObjects'
import * as types from '@/interfaces/valuation/types/LocalityValuationStep'
import store from '@/store'
import { AddressCM, AddressCMService } from '@/services/location/addressCM'
import {
  HouseNumberCM,
  HouseNumberCMService,
} from '@/services/location/houseNumberCM'
import { ProjectCM, ProjectCMService } from '@/services/location/projectCM'

export const idValueObject = (object: any): IdValueObject[] => {
  if (!object) {
    return []
  }

  return keys(object).map(id => ({ id: Number(id), value: object[id] }))
}

export function createErrorMessage() {
  const message = createMessage(
    'Seznam adres není dostupný. Zkuste to prosím později.'
  )
  store.dispatch('app/addTempMessage', { message })
}

export const defaultLocation: {
  [types.LocationType.District]: types.LocationDistrict
  [types.LocationType.Address]: types.LocationAddress
  [types.LocationType.GPS]: types.LocationGps
  [types.LocationType.Project]: types.LocationProject
} = {
  [types.LocationType.District]: {
    locationCadastralRegion: '',
    locationCadastralRegionId: 0,
    locationCadastralDistrict: '',
    locationCadastralDistrictId: 0,
    locationCadastralArea: '',
    locationCadastralAreaId: 0,
    locationHouseNumber: '',
    locationHouseNumberId: 0,
  },
  [types.LocationType.Address]: {
    locationAddressRegion: '',
    locationAddressRegionId: 0,
    locationAddressDistrict: '',
    locationAddressDistrictId: 0,
    locationAddress: '',
    locationAddressId: 0,
    locationAddressStreet: '',
    locationMunicipality: '',
    locationMunicipalityId: 0,
  },
  [types.LocationType.GPS]: {
    locationLat: '0.000000',
    locationLng: '0.000000',
  },
  [types.LocationType.Project]: {
    locationProjectRegion: '',
    locationProjectRegionId: 0,
    locationProjectDistrict: '',
    locationProjectDistrictId: 0,
    locationProject: '',
    locationProjectId: 0,
    locationProjectBuilding: '',
    locationProjectBuildingId: 0,
  },
}

const LocationService: {
  [types.LocationType.Address]: AddressCMService
  [types.LocationType.District]: HouseNumberCMService
  [types.LocationType.Project]: ProjectCMService
  [types.LocationType.GPS]: {}
} = {
  [types.LocationType.Address]: AddressCM,
  [types.LocationType.District]: HouseNumberCM,
  [types.LocationType.Project]: ProjectCM,
  [types.LocationType.GPS]: {},
}

export default LocationService
